import React from "react";

import { useTranslation } from "react-i18next";

import { Drawer } from "components/Drawer";
import SearchEmpty from "components/SearchEmpty";

import { handleGroupedList, handleList } from "./constants";
import { IDownloadsByHearingFile } from "./interface";
import { ContentList } from "./styles";
import { usePermissions } from "../../hooks/permission";
import { FORMS_HEARING } from "../../utils/entities/permission";

export const DownloadsByHearingFile: React.FC<IDownloadsByHearingFile> = ({
  id,
  title,
  openDrawer,
  emptyMessage,
  listDownloads,
  isInqueritoProduct,
  tooltipMessage,
  setItemClicked,
  setOpenDrawer,
  userId,
  onApply,
  onClose,
}) => {
  const { t } = useTranslation();
  const { export: exportFiles } = usePermissions(FORMS_HEARING.HEARING_FILE);
  const isDownloadDisabled = (download: any) => {
    const isConfidential = Boolean(download?.confidential);
    const downloadUserId = download?.userId ?? download?.UserId;

    return (
      Boolean(isInqueritoProduct) &&
      isConfidential &&
      Number(downloadUserId) !== Number(userId)
    );
  };

  return (
    <Drawer
      id={id}
      title={title}
      onApply={onApply}
      onClose={() => {
        onClose();
        setOpenDrawer(false);
      }}
      open={openDrawer}
      footer="none"
      paddingLeft={20}
      paddingRight={20}
    >
      {exportFiles && listDownloads && listDownloads.length > 0 ? (
        <ContentList>
          {isInqueritoProduct
            ? handleGroupedList(
                listDownloads,
                setItemClicked,
                tooltipMessage,
                t,
                isDownloadDisabled,
              )
            : handleList(listDownloads, setItemClicked, tooltipMessage, t)}
        </ContentList>
      ) : (
        <SearchEmpty typeIcon="file" textMessage={emptyMessage} />
      )}
    </Drawer>
  );
};
